import React, { PropTypes, Component } from 'react';

export default class OpinionLab extends Component {

  constructor(props) {
    super(props);
  }

  static constructOpinionLabUrl(initTime = "", props) {
      if (typeof document === "undefined" || typeof window === "undefined") {
        return null;
      }

      const {
        rLogId,
        fptiPgrp,
        country,
        locality,
        hostName
      } = props;

      const {
        screen: {
          height,
          width
        } = {}
      } = window || {};


      const currentTime = (new Date()).getTime();
      const pageReferer = `https://${country}.paypal.com/${locality}/00/${escape(fptiPgrp.replace(/\s|\//g, '_'))}.page`;
      const baseUrl = "https://secure.opinionlab.com/ccc01/comment_card.asp?";
      const partA = `time1=${currentTime}&time2=${currentTime}&referer=${pageReferer}&prev=${encodeURIComponent(document.referrer)}`
      const partB = `&height=${height}&width=${width}&custom_var=${OpinionLab.getCustomVar(props)}`
      return `${baseUrl}${partA}${partB}`
  }

  static getCustomVar(props) {
      const {
        rLogId,
        fptiPgrp,
        country,
        locality,
        hostName
      } = props;

      return `${rLogId}|Unknown|${fptiPgrp}|${country}|${locality}|Unknown|Unknown|Unknown|Unknown`
  }

  componentDidMount() {

    const {
      rLogId,
      fptiPgrp,
      country,
      locality,
      hostName
    } = this.props;

    window.PAYPAL = window.PAYPAL || {};
    window.PAYPAL.opinionLabVars = {
      "siteCatalystPageName": "",
      "siteCatalystC7": "",
      "siteCatalystAccountNumber": "",
      "feedback_link": "Feedback",
      "isPaymentFlow": false,
      "isSiteRedirect": false,
      "languageCode": locality,
      "countryCode": country,
      "serverName": hostName,
      "commentCardCmd": "myCommand",
      "accountNumber": "",
      "miniBrowser": false,
      "sitefb_plus_icon": "https://www.paypalobjects.com/en_US/i/scr/sm_333_oo.gif",
      "rLogId": rLogId,
      "showSitefbIcon": false,
      "className": "feedback",
      "optOut": false,
      "page": fptiPgrp
    }
  }

  render() {
    return null;
  }
}

OpinionLab.propTypes = {
  rLogId: PropTypes.string,
  fptiPgrp: PropTypes.string,
  country: PropTypes.string,
  locality: PropTypes.string,
  hostName: PropTypes.string
}



/** WEBPACK FOOTER **
 ** ./src/Opinionlab/index.js
 **/